import React, { Component } from "react";
import "./styles";
import Launcher from "./components/Launcher"; // Chatbot launcher
import _ from "lodash";

import { NAME } from "../../../../constants";

import { Auth, API, Interactions } from "aws-amplify";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getChatConfigProp, linkClickable } from "../../../../common/utils";
import { getUserDisplayName } from "../../../../utils";
import { AWS, Credentials } from "@aws-amplify/core";
import { bindActionCreators } from "redux";
import {
  fetchUserSkillHistory,
  updateAllTimeUserHistory,
  updateBubbles,
  updateChatVisibility,
  welcomeMessageSent as welcomeMessageSentFunction
} from "../../../../redux/actions/chatActions";

import {getEnvironmentName} from "../../../../utils"
const environment = getEnvironmentName()
const config = require("app_configuration").CONFIGURATION[environment];

// const bubbles_lst = [
//   { type: "intent", name: "App Dev", utterance: "App Dev" },
//   {
//     type: "hierarchy",
//     name: "Advanced Analytics",
//     utterance: "advanced analytics",
//     children: [
//       { type: "intent", name: "Big Data", utterance: "Big Data" },
//       { type: "intent", name: "Enterprise Voice", utterance: "Enterprise Voice" },
//       { type: "intent", name: "Managed Services", utterance: "Managed Services" }
//     ]
//   },
//   { type: "intent", name: "Reporting and Visualization", utterance: "Reporting " },
//   { type: "intent", name: "Big Data", utterance: "Big Data" },
//   { type: "intent", name: "Enterprise Voice", utterance: "Enterprise Voice" },
//   { type: "intent", name: "Managed Services", utterance: "Managed Services" }
// ];

class Chat extends Component {
  constructor(props) {
    super(props);

    const _defaultUserImage = "https://cdn.pixabay.com/photo/2016/04/01/11/25/avatar-1300331_960_720.png";

    this.state = {
      // isOpen: false,
      loadingMessages: null,
      historyLoaded: false,
      initialMount: null,
      bubbles: null,
      source: null,
      newMessagesCount: 0,
      messageList: [
        // { type: "text", author: "me", data: { text: "Why don't they have salsa on the table?" } },
        // { type: "text", author: "them", data: { text: "What do you need salsa for?" } }
      ],
      sessionAttributes: {},
      botIsTyping: false,
      audioPlayingState: null,
      userImage: _.get(
        this.props.cognitoUser,
        "attributes.picture",
        _.get(this.props.cognitoUser, "challengeParam.userAttributes.picture", _defaultUserImage)
      ),
      userFullName: getUserDisplayName(this.props.cognitoUser)
    };
  }
  componentWillMount() {
    this.setState({ initialMount: true });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      nextProps.chat &&
      this.props.chat &&
      nextProps.chat.chatUserHistory === this.props.chat.chatUserHistory &&
      !this.props.chat.chatUserHistory
    ) {
      this.props.fetchUserSkillHistory(true);
    }
    if (
      nextProps.chat &&
      this.props.chat &&
      nextProps.chat.chatUserHistory &&
      _.get(nextProps, "chat.chatUserHistory.data", false) &&
      _.get(nextProps, "chat.chatUserHistory.data", []) !== _.get(this.props, "chat.chatUserHistory.data", [])
    ) {
      this.setState({ loadingMessages: true }, () => {
        this.loadUserHistoryInChat(nextProps.chat.chatUserHistory);
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.initialMount && this.state.historyLoaded) {
      this.setState({ initialMount: false });
    }

    if (prevState.audioPlayingState === "bubble_clicked" || prevState.audioPlayingState === "error") {
      this.setState({ audioPlayingState: null });
    }

    if (prevState.messageList != this.state.messageList) {
      this.props.updateAllTimeUserHistory(this.state.messageList);
    }

    if (!this.state.initialMount && prevState.initialMount) {
      let lastMessage = localStorage.getItem("last_chat_message");
      if (lastMessage) {
        this.props.updateChatVisibility(true);
        this._onMessageWasSent(JSON.parse(lastMessage));
        localStorage.removeItem("last_chat_message");
      } else {
        if (!_.get(this.state.messageList[this.state.messageList.length - 2], "hidden", false)) {
          this._onMessageWasSent({
            author: "me",
            type: "text",
            data: { text: "open" },
            hidden: true
          });
          this.props.welcomeMessageSentFunction(true);
        }
      }
    }
  }

  componentDidMount() {
    if (!document.getElementById("responsum_audio")) {
      let audio = document.createElement("audio");
      audio.setAttribute("id", "responsum_audio");
      document.body.appendChild(audio);
    }

    if (this.state.messageList.length === 0 && _.get(this.props, "chat.chatUserHistory.allTimeUserHistory", false)) {
      this.setState({ messageList: this.props.chat.chatUserHistory.allTimeUserHistory, source: "history" });
    }
  }

  loadUserHistoryInChat(responseData) {
    let historyState = [
      // { type: "text", author: "me", data: { text: "Why don't they have salsa on the table?" } },
      // { type: "text", author: "them", data: { text: "What do you need salsa for?" } }
      ...this.state.messageList
    ];
    let utterance;
    let response;
    let spliceCount = 0;
    _.forEachRight(responseData.data, item => {
      utterance = item["UserInput"];
      response = item["ResponseCardText"];
      if (_.get(responseData, "initialLoad", true)) {
        historyState.push({
          type: "text",
          author: "me",
          data: { text: utterance }
        });
        historyState.push({
          type: "text",
          author: "them",
          data: { text: response }
        });
      } else {
        historyState.splice(spliceCount, 0, {
          type: "text",
          author: "me",
          data: { text: utterance }
        });
        historyState.splice(spliceCount + 1, 0, {
          type: "text",
          author: "them",
          data: { text: response }
        });
        spliceCount = spliceCount + 2;
      }
    });

    this.setState({ messageList: historyState, source: "history", loadingMessages: false, historyLoaded: true });
  }

  play = (buffer, callback) => {
    try {
      this.setState({ audioPlayingState: "playing" });
      let myBlob = new Blob([buffer], { type: "audio/mpeg" });
      let audio = document.getElementById("responsum_audio");
      let objectUrl = window.URL.createObjectURL(myBlob);
      audio.src = objectUrl;
      audio.addEventListener("ended", function() {
        audio.currentTime = 0;
        if (typeof callback === "function") {
          callback();
        }
      });
      audio.play().catch(e => {
        console.log("audio.play().catch", e);
      });
      // console.log("Audio", audio);
    } catch (e) {
      console.log("ERROR", e);
    }
  };

  sendBotRequest = message => {
    this.setState({ botIsTyping: true, isBubbleDrillDown: false });

    Auth.currentSession()
      .then(data => {
        Credentials.set(data, "session").then(credentials => {
          AWS.config.update({
            credentials
          });
          let sessionAttributes = _.omit(
            _.merge({}, this.state.sessionAttributes, {
              appId: this.props.skill.ID,
              accessToken: data.getAccessToken().getJwtToken()
            }),
            ["cardBody"]
          );
          Interactions.send(this.props.skill.lex_bot_name, {
            options: {
              messageType: message.type,
              sessionAttributes: sessionAttributes,
              requestAttributes: {
                source: "portal-responsum",
                bubbleUsage: _.get(message, "source", "chat") === "bubble" ? "true" : "false"
              },
              userId: "EVChatbot-" + this.props.cognitoUser.attributes.sub
            },
            content: message.type === "voice" ? message.data.audio : message.data.text
          }).then(
            response => {
              if (
                _.get(response, "dialogState", "NotElicit") === "ElicitSlot" ||
                _.get(response, "dialogState", "NotElicit") === "ElicitIntent"
              ) {
                // localStorage.setItem("last_chat_message");
                message.data.dialogElicitSlot = true;
              }

              this.setState({
                botIsTyping: false,
                sessionAttributes: _.get(response, "sessionAttributes", {})
              });

              if (_.get(response, "sessionAttributes.connectionId", undefined)) {
                localStorage.setItem("ConnectionId", _.get(response, "sessionAttributes.connectionId", undefined));
              }

              let requestId = _.get(response, "sessionAttributes.requestId", null);
              let endpoint = "skills/" + this.props.skill.ID + "/bubbles";
              if (requestId) endpoint = endpoint + "?requestId=" + requestId + "&source=" + "portal-responsum";
              API.get(config.AWS_API_NAME, endpoint, null).then(bubbles => {
                this._bubblesState(bubbles);
                // //Log chatbot response
                // if (bubbles /*response.sessionAttributes.bubbleResponse*/) {
                //
                // } else {
                //   this.setState({
                //     bubbles: []
                //   });
                // }
                // unselect bubble
                // document.querySelectorAll(".bubbles").forEach(function(elem) {
                //   elem.classList.remove("activeBubble");
                // });
              });

              if (message.type === "voice") {
                message.data.text = response.inputTranscript;
                message.type = "text";

                if (response.audioStream.length === 0) {
                  this.setState({ audioPlayingState: "playing" }, () => {
                    this.setState({ audioPlayingState: "stopped" });
                  });
                } else {
                  this.play(response.audioStream, () => {
                    this.setState({ audioPlayingState: "stopped" });
                  });
                }

                delete message.data.audio;

                this.setState({
                  messageList: [...this.state.messageList, message],
                  source: "typing"
                });
              } else if (message.type === "transcript") {
                message.type = "text";

                if (response.audioStream.length === 0) {
                  this.setState({ audioPlayingState: "playing" }, () => {
                    this.setState({ audioPlayingState: "stopped" });
                  });
                } else {
                  this.play(response.audioStream, () => {
                    this.setState({ audioPlayingState: "stopped" });
                  });
                }

                delete message.data.audio;
                // this.setState({
                //   messageList: [...this.state.messageList, message]
                // });
              }

              let msg = _.get(
                response,
                "sessionAttributes.cardBody",
                _.get(response, "sessionAttributes.PlainText", _.get(response, "message", ""))
              );

              if (msg.includes("a href") === false) {
                msg = linkClickable(msg, "response");
              }

              this._sendMessage(msg);
            },
            error => {
              this.setState({ botIsTyping: false });
              if (error) {
                console.error(error);
                this.setState({ audioPlayingState: "error" });
                if (error.toString().includes("There is no alias named demo for the bot named")) {
                  this._sendMessage(
                    "Your environment is not ready to use yet. Please try a moment later. If issue persists please contact support."
                  );
                } else if (error.toString().includes("RequestTimeoutException")) {
                  this._sendMessage("Responsum request is too long. Request recoding limit is 15 seconds.");
                } else if (error.toString().includes("has status BUILDING")) {
                  this._sendMessage("Responsum is building... Please try again a moment later.");
                } else {
                  this._sendMessage(error.message);
                }
              }
            }
          );
        });
      })
      .catch(err => console.log(err));
  };

  _onMessageWasSent(message) {
    if (_.get(message, "source", "") === "bubble") {
      this.setState({ audioPlayingState: "bubble_clicked" });
    }
    // console.log("message", message);
    // localStorage.removeItem("last_chat_message");
    // Provide a bot name and user input
    this.sendBotRequest(message);

    let copy = _.clone(message);

    if (copy.type !== "voice") {
      copy.type = copy.type === "transcript" ? "text" : copy.type;
      this.setState({
        messageList: [...this.state.messageList, copy],
        source: "typing"
      });
    }
  }

  _handleClick() {
    this.setState({
      isOpen: !this.state.isOpen,
      newMessagesCount: 0
    });

    this.props.updateChatVisibility(!this.props.chatVisible);
  }

  _sendMessage = text => {
    if (text.length > 0) {
      const newMessagesCount = this.props.chat.chatVisible
        ? this.state.newMessagesCount
        : this.state.newMessagesCount + 1;
      this.setState({
        newMessagesCount: newMessagesCount,
        messageList: [
          ...this.state.messageList,
          {
            author: "them",
            type: "text",
            data: { text }
          }
        ],
        source: "typing"
      });
    }
  };

  _onDrillDown(bubbles) {
    this.setState({ source: "hierarchy" });
    this._bubblesState(bubbles);
  }

  _bubblesState(bubbles) {
    let _bubbles = Array.isArray(bubbles) ? bubbles : bubbles.bubbles;
    let type = _.get(bubbles, "type", "drillDown");
    let isDrillDown;
    switch (type) {
      case "intent":
      case "slot":
      case "confirmation":
      case "drillDown":
      case "answer":
        isDrillDown = true;
        break;
      case "skill":
        isDrillDown = false;
        break;
      default:
        isDrillDown = false;
    }
    // return {
    //   bubbles: _bubbles,
    //   isBubbleDrillDown: isDrillDown
    // };

    this.props.updateBubbles({
      bubbles: _bubbles,
      isBubbleDrillDown: isDrillDown
    });
  }

  _bubblesTopLevel() {
    let endpoint = "skills/" + this.props.skill.ID + "/bubbles";

    API.get(config.AWS_API_NAME, endpoint, null).then(bubbles => {
      this._bubblesState(bubbles);
    });
  }

  _onBubbleAnswer(bubble) {
    const newMessagesCount = this.props.chat.chatVisible
      ? this.state.newMessagesCount
      : this.state.newMessagesCount + 1;
    this.setState({
      newMessagesCount: newMessagesCount,
      messageList: [
        ...this.state.messageList,
        {
          author: "me",
          type: "text",
          data: { text: bubble.question }
        }
      ],
      source: "typing"
    });
    let that = this;
    setTimeout(function() {
      const newMessagesCount = that.props.chat.chatVisible
        ? that.state.newMessagesCount
        : that.state.newMessagesCount + 1;
      const message = {
        text: "<b>" + bubble.question + "</b>\n" + bubble.answer + "\n\nDoes this answer your question?"
      };
      that.setState({
        newMessagesCount: newMessagesCount,
        messageList: [
          ...that.state.messageList,
          {
            author: "them",
            type: "text",
            data: message
          }
        ],
        source: "typing"
      });
    }, 450);
  }

  removeDialogElicit = () => {
    let result = _.map(this.state.messageList, object => {
      return _.omit(object, "data.dialogElicitSlot");
    });

    this.setState({ messageList: result });
  };

  render() {
    if (!this.props.showChatbot) return <></>;
    return (
      <div>
        <Launcher
          source={this.state.source}
          agentProfile={{
            // imageUrl: "https://api.adorable.io/avatars/34/abott@adorable.png",
            teamName: NAME
          }}
          handleClick={this._handleClick.bind(this)}
          isOpen={this.props.assistantPage ? this.props.assistantPage : this.props.chatVisible}
          messageList={this.state.messageList}
          removeDialogElicit={this.removeDialogElicit}
          onMessageWasSent={this._onMessageWasSent.bind(this)}
          showEmoji={false}
          newMessagesCount={this.state.newMessagesCount}
          bubbles={_.get(this.props, "chat.bubbleConfig.bubbles", [])}
          isBubbleDrillDown={_.get(this.props, "chat.bubbleConfig.isBubbleDrillDown", false)}
          bubblesTopLevel={this._bubblesTopLevel.bind(this)}
          bubblesOnMessageWasSent={this._onMessageWasSent.bind(this)}
          bubbleDrillDown={this._onDrillDown.bind(this)}
          bubbleAnswer={this._onBubbleAnswer.bind(this)}
          botIsTyping={this.state.botIsTyping}
          playingState={this.state.audioPlayingState}
          userImage={this.state.userImage}
          userFullName={this.state.userFullName}
          sidebarIsOpen={this.props.sidebarIsOpen} // to determine chat drag range
          assistantPage={this.props.assistantPage}
        />
      </div>
    );
  }
}

Chat.propTypes = {
  cognitoUser: PropTypes.object,
  skill: PropTypes.object
};

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    skill: state.skill,
    chat: state.chat,
    chatVisible: getChatConfigProp(state, "chatVisible"),
    welcomeMessageSent: _.get(state, "chat.welcomeMessageSent", false),
    showChatbot: _.get(state, "chat.showChatbot", true)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        fetchUserSkillHistory,
        updateChatVisibility,
        updateAllTimeUserHistory,
        welcomeMessageSentFunction,
        updateBubbles
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Chat);

export { Chat };
